import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompaniesComponent } from './companies/companies.component';
import { CompaniesCreateComponent } from './companies-create/companies-create.component';
import { CompaniesEditComponent } from './companies-edit/companies-edit.component';
import { COMPANIES_PATHS } from './companies';

import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: COMPANIES_PATHS.companies,
    component: CompaniesComponent,
    canActivate: [AuthGuard],
    data: { animation: 'CompaniesPage', permission: 'partnership.get' },
  },
  {
    path: COMPANIES_PATHS.companies_create,
    component: CompaniesCreateComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'CompaniesCreatePage',
      permission: 'partnership.add',
    },
  },
  {
    path: COMPANIES_PATHS.companies_edit,
    component: CompaniesEditComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'CompaniesEditPage',
      permission: 'partnership.edit',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompaniesRoutingModule {}
